import isEqual from 'lodash/isEqual'

import eventChannel from '../eventChannel'

import * as events from './events'
import * as user from './user'
import store from './store'

let curr

function handleChange() {
  const state = store.getState()
  const prev = curr || state
  curr = state

  // event
  if (!isEqual(events.current(curr), events.current(prev))) {
    eventChannel.trigger(eventChannel.eventChanged)
    eventChannel.trigger(eventChannel.userChanged)
  }

  // user
  if (!isEqual(user.user(curr), user.user(prev))) {
    eventChannel.trigger(eventChannel.userChanged)
  }
}

let unsubscribe

export function init() {
  // running once makes things (like tests) work better (read: work)
  handleChange()
  // calling subscribe returns a complementary unsubscribe function
  unsubscribe = store.subscribe(handleChange)
}

export function deinit() {
  // we unsubscribe ourselves from changes to the store
  unsubscribe()
}

export function documentReady() {
  init()
}
